<script setup>
import { reactiveOmit } from '@vueuse/core';
import { RangeCalendarCellTrigger, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';
import { buttonVariants } from '@/Components/ui/button';

const props = defineProps({
    day: { type: null, required: true },
    month: { type: null, required: true },
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
    class: { type: null, required: false },
});

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <RangeCalendarCellTrigger
        :class="
            cn(
                buttonVariants({ variant: 'ghost' }),
                'h-8 w-8 !rounded-full p-0 font-normal data-[selected]:opacity-100',
                '[&[data-today]:not([data-selected])]:border-2 [&[data-today]:not([data-selected])]:border-accent',
                // Selection Start
                'data-[selection-start]:text-primary-foreground data-[selection-start]:hover:text-primary-foreground data-[selection-start]:focus:text-primary-foreground data-[selection-start]:!rounded-l-full data-[selection-start]:bg-primary data-[selection-start]:hover:bg-primary data-[selection-start]:focus:bg-primary',
                // Selection End
                'data-[selection-end]:text-primary-foreground data-[selection-end]:hover:text-primary-foreground data-[selection-end]:focus:text-primary-foreground data-[selection-end]:!rounded-r-full data-[selection-end]:bg-primary data-[selection-end]:hover:bg-primary data-[selection-end]:focus:bg-primary',
                // Outside months
                'data-[outside-view]:text-muted-foreground [&[data-outside-view][data-selected]]:text-muted-foreground data-[outside-view]:opacity-50 [&[data-outside-view][data-selected]]:opacity-30',
                // Disabled
                'data-[disabled]:text-muted-foreground data-[disabled]:opacity-50',
                // Unavailable
                'data-[unavailable]:text-destructive-foreground data-[unavailable]:line-through',
                props.class,
            )
        "
        v-bind="forwardedProps"
    >
        <slot />
    </RangeCalendarCellTrigger>
</template>
